// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import getColor from "@insite/mobius/utilities/getColor";
import Search from "@rugby/XDL/Icons/Search";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        padding: 20px 20px 0;
        background: ${getColor("common.ui3")};
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
    `,
};

searchWithinStyles.searchTextField = {
    iconProps: { src: Search, color: "primary", size: 18 },
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

searchWithinStyles.titleText = {
    variant: "p",
    css: css`
        font-size: 18px;
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 20px;
    `,
};
